import React from 'react'
import styles from '../Proj5Folder/Proj5.module.css'
import hospital7p1 from '../../Images/d1.jpeg'
import hospital7p2 from '../../Images/d2.jpeg'
import hospital7p3 from '../../Images/d3.jpeg'





export default function NewDamiettaEyeMedicalCenter() {
  return (

    <>
        <div className="container my-5 py-5 ">
          <div className="row align-items-center">
            <div className="col-md-6">
                <h3 className={`${styles.color} my-3`}> New Damietta Eye Medical Center ​</h3>
                <p> Project description: Medical Center Building  </p>
                <p>Type of contract: Design </p>
                <p>Type of works : Architectural coordination's and Electromechanical </p>
            </div>
            <div className="col-md-6">
                <img src={hospital7p1} alt="achegy" className='img-fluid'/>
            </div>   
          </div>
          <div className="row my-5 pb-5">
         
         <div className="col-md-6 my-2 text-center">
            <img src={hospital7p2} alt="achegy" className={`${styles.imgSizeProj}`}/> 
         </div>
         <div className="col-md-6 my-2 text-center">
            <img src={hospital7p3} alt="achegy" className={`${styles.imgSizeProj}`}/> 
         </div>
    
   
     
       
       </div>
        </div>

    </>
  )
}
